<template lang="html">
  <layout-private>
    <div class="row">
      <div class="col-12">
        <h2>Account</h2>
        <hr />

        <ul class="nav nav-sub">
          <li class="nav-item">
            <router-link to="/account" exact-active-class="active" class="nav-link">Billing</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/profile" exact-active-class="active" class="nav-link">Edit User Profile</router-link>
          </li>
        </ul>

        <p v-if="!this.verified" class="alert alert-app">
          <span v-if="!verifyEmailSent"><strong>Your account isn't verified.</strong> Please check your email to verify your account and protect your data. <a href="#" @click.prevent="verifyEmail">Resend the email.</a></span>
          <span v-if="verifyEmailSent">Email verification sent to {{ this.email }}. Please check your inbox!</span>
        </p>

        <p v-if="!hasPhoneMFAFactor" class="alert alert-app">
          <span><strong>Upgrade your account security to enable all features.</strong> Multi-factor authentication (MFA) via text message is required to enable HIPAA compliant features. <router-link to="/profile" exact-active-class="active">Set Up MFA on Your User Profile</router-link></span>
        </p>

        <div v-if="this.account && this.account.restricted && !this.account.restricted.stripe_connected_account_id" class="stripe-connect">
          <h3 class="light-weight">Stripe Account</h3>
          <p><a :href="'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=' + stripeConnectClientId + '&scope=read_write&state=' + account['.key']" class="btn-stripe-connect"><img src="../assets/img/btn-stripe-blue-on-light@2x.png" width="190px" height="33px" alt="Connect with Stripe" /></a></p>
        </div>

        <div v-if="this.account && this.account.restricted && this.account.restricted.stripe_connected_account_id" class="stripe-connect">
          <h3 class="light-weight">Stripe Account</h3>
          <p><strong>Status: </strong><em>connected</em></p>
        </div>

        <!-- <div v-if="hasPhoneMFAFactor" class="section-odapikey">
          <h3>Open Dental Connection</h3>
          <p><em>Enter your Open Dental Customer API key below to have Health Assurance subscription payments posted into Open Dental for members who have a PatNum saved on their profile. Don't have a key? <a href="mailto:info@healthassuranceplan.com">Email Support</a>.</em></p>
          <p v-if="odApiKey && !editOdApiKey"><strong>Open Dental Customer API Key:</strong> {{ odApiKey }}</p>
          <p v-if="!editOdApiKey"><button class="btn btn-app" @click="editOdApiKey=true"><i class="far fa-pencil"></i> Add/Edit API Key</button></p>
          <p v-if="editOdApiKey" class="form-odapikey d-flex">
            <input v-model="odApiKey" name="odApiKey" class="form-control" placeholder="Enter API Key" type="text" @keyup.enter="saveOdApiKey"/>
            <i v-if="loadingApiKey" class="far fa-spinner-third fa-spin fa-2x"></i>
            <button class="btn btn-icon" @click="saveOdApiKey"><i class="far fa-pencil"></i> Save</button>
            <button class="btn btn-link" @click="editOdApiKey=false">cancel</button>
          </p>
          <list-errors :errors="errors"></list-errors>
        </div> -->

      </div> <!-- /.col -->

    <router-view :plans="plans"></router-view>

  </div> <!-- /.row -->
  </layout-private>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import Firebase from 'firebase/compat/app'
import 'firebase/auth'
import LayoutPrivate from '../components/LayoutPrivate.vue'
import ListErrors from '../components/ListErrors.vue'

export default {
  props: ['plans'],
  components: {
    LayoutPrivate, ListErrors, 
  },
  data () {
    return {
      verifyEmailSent: false,
      errors: [],
      // odApiKey: null,
      // editOdApiKey: false,
      loadingApiKey: false,
    }
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'account', 'isPracticeUser']),
    stripeConnectClientId () {
      if(process.env.VUE_APP_STRIPE_MODE === 'live') {
        return "ca_FridlESuQVpasKXXqvgE5AOW0Q2f3RnQ"
      }
      return "ca_FridJeDc2JSfIibMbTTmSZ9VBndSl2ot"
    },
    email() {
      if(this.user) {
        return this.user.email;
      }
      return null;
    },
    verified() {
      if(this.user) {
        return this.user.emailVerified;
      }
      return null;
    },
    hasPhoneMFAFactor() {
      if(this.user && this.user.multiFactor && this.user.multiFactor.enrolledFactors && this.user.multiFactor.enrolledFactors.some(f => f.factorId == "phone")) {
        return true;
      }
      return false;
    },
  },
  watch: {
    user_props() {
      if(this.user_props) {
        // this.loadOdApiKey();
      }
    },
  },
  methods: {
    // loadOdApiKey () {
    //   if(!this.isPracticeUser || !this.hasPhoneMFAFactor || !this.user || !this.user.uid || !this.user_props || !this.user_props.owned_account_id) {
    //     return;
    //   }
    //   const locDocPath = `owners/${this.user.uid}/accounts/${this.user_props.owned_account_id}`;
    //   // console.log({locDocPath});
    //   // save to firestore
    //   Vue.firestore
    //     .doc(locDocPath)
    //     .get()
    //     .then(docSnap => {
    //       if(docSnap && docSnap.exists && docSnap.data().open_dental_customer_api_key) {
    //         this.odApiKey = docSnap.data().open_dental_customer_api_key;
    //         return true;
    //       }
    //       return false;
    //     })
    //     .catch(err => console.log(err));
    // },
    // saveOdApiKey () {
    //   this.loadingApiKey = true;
    //   this.errors = [];
    //   // validate patNum
    //   console.log('odApiKey',this.odApiKey.toString().length);
    //   if(!this.odApiKey || this.odApiKey.toString().length < 5 || this.odApiKey.toString().length > 30) {
    //     this.errors.push("Invalid API Key");
    //   }
    //   // validate required data exists
    //   if(!this.isPracticeUser || !this.hasPhoneMFAFactor || !this.user || !this.user.uid || !this.user_props || !this.user_props.owned_account_id) {
    //     this.errors.push("You're missing the permissions to save API Keys.");
    //   }
    //   if(this.errors.length) {
    //     this.loadingApiKey = false;
    //     return;
    //   }
    //   const locUpdate = {
    //     open_dental_customer_api_key: this.odApiKey,
    //     practice_account_id: this.user_props.owned_account_id,
    //     practice_account_owner_uid: this.user.uid,
    //   };
    //   // console.log({locUpdate});
    //   const locDocPath = `owners/${this.user.uid}/accounts/${this.user_props.owned_account_id}`;
    //   // console.log({locDocPath});
    //   // save to firestore
    //   Vue.firestore
    //     .doc(locDocPath)
    //     .set(locUpdate)
    //     .then(() => {
    //       console.log('saved api key');
    //       this.editOdApiKey = false;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       this.errors = [`${err.message}`];
    //     })
    //     .then(() => {
    //       this.loadingApiKey = false;
    //     })
    // },
    async verifyEmail () {
      let result = await this.$firebase.verifyEmail()
      if(result == true) {
        this.verifyEmailSent = true;
      }
    },
  },
  mounted() {
    if(this.user_props) {
      // this.loadOdApiKey();
    }
  },

}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.stripe-connect h3 {
  margin-bottom: 10px;
}
.section-odapikey .form-control,
.section-odapikey .btn {
  margin-left: 15px;
}
.section-odapikey .form-control {
  margin-bottom: 0;
  margin-left: 0;
}
.section-odapikey .btn:last-child {
  margin: 0;
}
.section-odapikey .btn {
  min-width: 75px;
}
@media (min-width: @screen-md-min) {
  .section-odapikey {
    max-width: 75%;
  }
}
@media (min-width: @screen-lg-min) {
  .section-odapikey {
    max-width: 50%;
  }
}
</style>
